/* eslint-disable spire/export-styles */
import { AuerState } from "@auer-steel/Store/AuerState";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import Button, { ButtonProps } from "@insite/mobius/Button";
import Clickable, { ClickableProps } from "@insite/mobius/Clickable";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";

import React from "react";
import { connect } from "react-redux";

export interface PayInvoiceButtonStyles {
    buttonStyles?: ButtonProps;
    clickableStyles?: ClickableProps;
}

const styles: PayInvoiceButtonStyles = {
    buttonStyles: {
        variant: "primary",
    },
    clickableStyles: {},
};

interface OwnProps {
    title: string;
    invoiceAmount: number;
    invoiceNumbers: string[];
    variant?: string;
    disabled?: boolean;
    extendedStyles?: PayInvoiceButtonStyles;
}

const mapStateToProps = (state: AuerState) => {
    return { payInvoiceUrl: getPageLinkByPageType(state, "PayInvoicePage")?.url };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

const PayInvoiceButton: React.FunctionComponent<Props> = props => {
    const [mergedStyles] = React.useState(() => mergeToNew(styles, props.extendedStyles));

    const removeDuplicateInvoiceNumbers = (invoiceNums:any) => {
        const newInvoiceNums: any[] = [];
        if(!invoiceNums){
            return newInvoiceNums;
        }
        invoiceNums.forEach((item:any) => {
            const ind = newInvoiceNums.findIndex(obj => obj === item);
            if (ind === -1) {
                newInvoiceNums.push(item);
            }
        });
        return newInvoiceNums;
    }
    const updatedInvoiceNumbers = removeDuplicateInvoiceNumbers(props.invoiceNumbers);

    const onClickHandler = () => {
        props.history.push(
            `${props.payInvoiceUrl}?invoiceNumbers=${updatedInvoiceNumbers.join(",")}&invoiceAmount=${
                props.invoiceAmount
            }`,
        );
    };
    if (props.variant === "clickable") {
        return (
            <Clickable {...mergedStyles.clickableStyles} onClick={onClickHandler} disabled={props.disabled}>
                {props.title}
            </Clickable>
        );
    }

    return (
        <Button {...mergedStyles.buttonStyles} onClick={onClickHandler} disabled={props.disabled}>
            {props.title}
        </Button>
    );
};

export default connect(mapStateToProps)(withHistory(PayInvoiceButton));
